// // rem等比适配配置文件
function setRem() {
  //最终分辨率为3840*2160
  // 当前页面屏幕分辨率相对于 基于1920*1080的缩放比例
  let baseSize = 50;
  const scale = document.documentElement.clientHeight / 1080;
  let size = baseSize * Math.min(scale, 2);
  document.getElementsByTagName("body")[0].style.background = "transparent";
  document.documentElement.style.fontSize = size + "px";
}
setRem();
window.onresize = function () {
  setRem();
};
